<template>
    <CardPage :section="12" :page="4" :nextDisabled="nextDisabled" ref="cardPage">
        <div>
            <p>
                In this activity, you’ll match images with the correct description of safe injection steps. Choose the correct description to go with each
                image. Always follow your medical provider’s instructions about injecting hormones.
            </p>
            <div v-if="!allStepsAnswered">
                <v-fade-transition mode="out-in">
                    <div :key="steps[currentStep].imageText">
                        <ResponsiveImage
                            :src="steps[currentStep].image"
                            :min-height="150"
                            flex="xs8"
                            :alt="steps[currentStep].imageText"
                            img-class="elevation-1"
                        ></ResponsiveImage>
                        <div v-for="(choice, index) in answerChoices" :key="index" class="grey lighten-3 pa-3 mb-1" @click.stop="answer(choice.id)" v-ripple>
                            <div v-html="choice.text"></div>
                        </div>
                    </div>
                </v-fade-transition>
            </div>
            <p v-else class="font-weight-bold font-italic">You've matched everything!</p>
        </div>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
        <template v-if="nextDisabled()" v-slot:actions>
            <v-spacer></v-spacer>
        </template>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        steps: get('section12/steps'),
        currentStep: get('section12/currentStep'),
        answerChoices: get('section12/answerChoices'),
        allStepsAnswered: get('section12/allStepsAnswered')
    },
    methods: {
        answer(step) {
            if (this.currentStep === step) {
                this.$refs.modalFeedback.show(true, 'That’s right!', () => {
                    this.$store.set(`section12/steps@${this.currentStep}.answered`, true);
                    if (!this.allStepsAnswered) {
                        this.$store.commit('section12/nextStep');
                    }
                    if (!this.nextDisabled()) {
                        this.$refs.cardPage.nextClick();
                    }
                });
            } else {
                this.$refs.modalFeedback.show(false, 'Try again!');
            }
        },
        nextDisabled() {
            return !this.allStepsAnswered;
        }
    }
};
</script>
